var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.linkClass,on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_c('Icon',{attrs:{"name":_vm.network.icon,"width":"54"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }